import {
  CHART_BUILDER_RUN_START,
  CHART_BUILDER_RUN_SUCCESS,
  CHART_BUILDER_RUN_FAIL,
  CHART_BUILDER_CLEAR,
  FETCH_DASHBOARD_SETTINGS_START,
  FETCH_DASHBOARD_SETTINGS_SUCCESS,
  FETCH_DASHBOARD_SETTINGS_FAIL,
  SAVE_DASHBOARD_SETTINGS_START,
  SAVE_DASHBOARD_SETTINGS_SUCCESS,
  SAVE_DASHBOARD_SETTINGS_FAIL,
} from './types';

const initialState = {
  loading: false,
  selection: null,
  result: null,
  error: null,
};

export default function chartBuilderReducer(state, action) {
  const s = state === undefined ? initialState : state;

  switch (action.type) {
    case CHART_BUILDER_RUN_START:
      return { ...s, loading: true, error: null, selection: action.payload.selection };
    case CHART_BUILDER_RUN_SUCCESS:
      return { ...s, loading: false, result: action.payload, error: null };
    case CHART_BUILDER_RUN_FAIL:
      return { ...s, loading: false, error: action.payload };
    case CHART_BUILDER_CLEAR:
      return { ...initialState };
    case FETCH_DASHBOARD_SETTINGS_START:
      return { ...state, loading: true, error: null };
    case FETCH_DASHBOARD_SETTINGS_SUCCESS:
      return { ...state, loading: false, settings: action.payload };
    case FETCH_DASHBOARD_SETTINGS_FAIL:
      return { ...state, loading: false, error: action.payload };
    case SAVE_DASHBOARD_SETTINGS_START:
      return { ...state, saving: true };
    case SAVE_DASHBOARD_SETTINGS_SUCCESS:
      return { ...state, saving: false, settings: action.payload };
    case SAVE_DASHBOARD_SETTINGS_FAIL:
      return { ...state, saving: false, error: action.payload };
    default:
      return s;
  }
}
